import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-735e8b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-names"
}
const _hoisted_2 = { class: "light-product-box" }
const _hoisted_3 = ["data-bs-target"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "product-names"
}
const _hoisted_6 = { class: "light-product-box" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "modal-header" }
const _hoisted_11 = {
  class: "modal-title",
  id: "pieceModalLabel"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_13 = { class: "modal-body text-center p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_inner_image_zoom = _resolveComponent("inner-image-zoom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.fileUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: "#",
              "data-bs-toggle": "modal",
              "data-bs-target": '#pieceModal' + _ctx.keyValue
            }, [
              _createElementVNode("img", {
                src: _ctx.imageUrl,
                class: "img-fluid thumbnail",
                alt: _ctx.libelle,
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
              }, null, 40, _hoisted_4)
            ], 8, _hoisted_3)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_vue_feather, { type: "camera-off" })
          ])
        ])),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'pieceModal' + _ctx.keyValue,
      tabindex: "-1",
      "aria-labelledby": "pieceModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.libelle), 1),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_inner_image_zoom, {
              src: _ctx.imageUrl,
              "zoom-src": _ctx.imageUrl,
              "zoom-type": "hover"
            }, null, 8, ["src", "zoom-src"])
          ])
        ])
      ])
    ], 8, _hoisted_7)
  ], 64))
}